import React from 'react';
import { motion } from 'framer-motion';
import { FiArrowRight, FiCheck } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const bullets = [
  'Staff-first, AI-fallback setup',
  'No main-number change required',
  'Captures missed, after-hours, and overflow calls',
  'Structured handoff to CRM, dispatch, email, SMS, or Slack',
];

const Hero = () => {
  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <section className="relative pt-32 pb-20 lg:pt-44 lg:pb-28 overflow-hidden" style={{ background: '#0a0a0a' }}>
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] rounded-full opacity-20"
          style={{ background: 'radial-gradient(ellipse, #2d6a4f 0%, transparent 70%)' }} />
      </div>
      <div className="max-w-5xl mx-auto px-6 lg:px-8 relative z-10">
        <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}>
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-semibold mb-8 border"
            style={{ background: '#111', borderColor: '#2a2a2a', color: '#888' }}>
            <span className="w-1.5 h-1.5 rounded-full bg-green-500 animate-pulse" />
            Managed service — implemented for you
          </div>
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold tracking-tight leading-none mb-6" style={{ color: '#f1f1f1' }}>
            Replace Voicemail<br />
            <span style={{ color: '#4ade80' }}>with AI.</span>
          </h1>
          <p className="text-lg md:text-xl max-w-2xl mb-10 leading-relaxed" style={{ color: '#888' }}>
            Your team still answers first. When nobody picks up, Valtivo catches the call, captures the details, and routes it cleanly — so missed calls stop turning into lost revenue.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 mb-12">
            <button onClick={() => scrollTo('booking-section')}
              className="group flex items-center justify-center gap-2 px-8 py-4 rounded-lg text-base font-semibold transition-all"
              style={{ background: '#f1f1f1', color: '#0a0a0a' }}>
              Book a Discovery Call
              <SafeIcon icon={FiArrowRight} className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </button>
            <button onClick={() => scrollTo('how-it-works')}
              className="flex items-center justify-center gap-2 px-8 py-4 rounded-lg text-base font-semibold border transition-all"
              style={{ borderColor: '#2a2a2a', color: '#888', background: 'transparent' }}>
              See How It Works
            </button>
          </div>
          <div className="flex flex-col sm:flex-row flex-wrap gap-4">
            {bullets.map((b, i) => (
              <div key={i} className="flex items-center gap-2">
                <div className="w-4 h-4 rounded-full flex items-center justify-center flex-shrink-0" style={{ background: '#1a3a2a' }}>
                  <SafeIcon icon={FiCheck} className="w-2.5 h-2.5" style={{ color: '#4ade80' }} />
                </div>
                <span className="text-sm" style={{ color: '#888' }}>{b}</span>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;